module.exports = __webpack_public_path__ + "img/Google.304058dd.png";